<template>
  <div>

    <import-container v-if="hasPermission('containers.create')" />
    
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5> {{ $t('Containers Filters') }} </h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col lg="12" md="12" class="mb-md-0 mb-2 text-left" >
            <label>{{ $t('Owners') }}</label>
            <v-select multiple :close-on-select="false" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                      v-model="filteredOwners"
                      label="name" :reduce="v => v.id"
                      :options="ownerFilterOptions" class="w-100"/>
          </b-col>
          <b-col lg="12" md="12" class="mb-md-0 mb-2 text-left" >
            <label>{{ $t('Contracts') }}</label>
            <v-select multiple :close-on-select="false" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                      v-model="filteredContracts"
                      label="name" :reduce="v => v.id"
                      :options="contractFilterOptions" class="w-100"/>
          </b-col>
          <b-col lg="12" md="12" class="mb-md-0 mb-2 text-left" >
            <label>{{ $t('Size') }}</label>
            <v-select multiple :close-on-select="false" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                      v-model="filteredSizes"
                      label="name" :reduce="v => v.id"
                      :options="sizeFilterOptions" class="w-100"/>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>


    <b-card no-body>
      <b-card-header class="pb-50">
        <h5> {{ $t('qualify tags') }} </h5>
      </b-card-header>
      <b-card-body>

        <div v-if="send_tags" class="loading_page">
          <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
        </div>

        <b-row>

          <b-col cols="12" md="12" xl="12">
            <b-form-group :label="$t('import from file')" label-for="containers_excl_file" :state="null">
              <b-form-file locale="ar" id="containers_excl_file"
                           @change="onFileChange($event)"
                           dir="ltr"
                           :placeholder="$t('select file')"
                           drop-placeholder="Drop file here..." />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group :label="`${$t('Compactors')}`">
              <v-select :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" v-model="qualify_form.compactor" :getOptionLabel="d => d.name"
                        :options="devices" :reduce="d => d.device_id" />
              <small v-if="false && ('devices' in [])" class="text-danger">
                {{ $t(errors['devices'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col md="6">

            <!-- checkbox button  -->
            <b-form-group>
              <b-form-checkbox-group
                  v-model="qualify_form.services"
                  :options="optionsChekcbox"
                  button-variant="primary"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mb-2" v-if="progress">
            <b-progress
                :value="progress_value"
                max="100"
                precision="2"
                show-value
                variant="primary"
                height="15px"
                class="progress-bar-primary"
            />
          </b-col>

          <b-col md="12" v-if="error">
            <ol>
              <li class="text-danger">
                {{$t('Another File Is Being Processing ...')}}
              </li>
            </ol>
          </b-col>

          <b-col md="12" v-if="errors">
            <ol>
              <li class="text-danger" v-for="error in errors">
                  {{$t(error[0])}}
              </li>
            </ol>
          </b-col>

          <b-col md="12">
            <b-button class="" variant="info" @click="sendQualification" type="button" v-if="hasPermission('send_qualification')">
              {{ $t('qualify tags') }}
            </b-button>
          </b-col>

        </b-row>
      </b-card-body>
    </b-card>


    <b-card style="position: relative">



      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>

      <!--        filters    -->

      <div class="m-2">
        <b-row>
          <b-col cols="3" md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="perPageOptions"
                      :clearable="false" class="per-page-selector d-inline-block mx-50"/>
            <label>{{ $t('entries') }}</label>
          </b-col>

          <b-col cols="6" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="search" class="d-inline-block mr-1" :placeholder="$t('filter by container name, code or tag')"/>
<!--              <b-button v-if="($store.state.auth.userData.roles.includes($roles.SUPER_ADMIN) || $store.getters['auth/user'].permissions.includes('containers.create'))" variant="primary"-->
<!--                        :to="{ name: 'containers.create' }">-->
<!--                <span class="text-nowrap">{{ $t('Create Container')}}</span>-->
<!--              </b-button>-->
            </div>
          </b-col>

          <b-col cols="3" md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0" >
            <b-button class="mr-1 ml-1" variant="info" v-b-modal.importModal type="button" v-if="hasPermission('containers.create')">
                {{ $t('Import') }}
            </b-button>

            <b-dropdown :text="$t('Export')" offset="25" variant="primary" class="mx-1">
                    <b-dropdown-item
                         v-for="exportable in [
                          {
                            label:'PDF',
                            exporter:'pdf'
                          },
                          {
                            label:'Excel',
                            exporter:'xlsx'
                          }
                         ]" 
                         :key="exportable.label"
                         class="text-center"
                         @click.prevent="() => {
                            downloadList(exportable.exporter)
                         }"
                    >
                    {{ $t(exportable.label) }}
                  </b-dropdown-item>
            </b-dropdown>

          </b-col>
        </b-row>
      </div>

      <b-table ref="refTable" class="position-relative" :items="fetchContainer" @sort-changed="onSortChanged" responsive :fields="tableColumns"
               no-local-sorting primary-key="id" show-empty empty-text="No matching records found">

        <template #cell(id)="data"> {{ data.index + 1 }} </template>

        <template #cell(actions)="data">
          <b-dropdown class="actionIcon" variant="link" no-caret :right="$store.state.appConfig.isRTL">
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body"/>
            </template>
            <b-dropdown-item v-if="hasPermission('containers.update')" :to="{ name: 'containers.edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Edit') }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} {{$t('to')}} {{ dataMeta.to }} {{$t('of')}} {{ dataMeta.total }} {{$t('entries')}}</span>
          </b-col>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination v-model="currentPage" :total-rows="dataMeta.total" :per-page="perPage" first-number last-number
                          class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18"/>
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18"/>
              </template>
            </b-pagination>

          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>

</template>

<script>

import { hasPermission } from '@/auth/utils'
import { OrbitSpinner } from 'epic-spinners'
import {
  BButton,
  BCard,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BDropdown,
  BDropdownItem,
  BInputGroup,
  BRow,
  BAlert,
  BTabs,
  BTab,
  BModal,
  BCardText,
  BTable,
  BPagination,
  BCardBody,
  BCardHeader,
  BFormFile,
  BFormCheckboxGroup, BProgress
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { computed, onUnmounted, ref, watch } from '@vue/composition-api'
import store from '@/store'
import RfidForm from '@/views/modules/rfid/components/Form'
import containerStoreModule from '@/app/containers/containerStoreModule'
import axios from '@/libs/axios'
import ImportContainer from './ImportContainer.vue'
import moment from 'moment'


export default {

  name: 'ListContainers',
  components: {
    BFormCheckboxGroup,
    BFormFile,
    BCardHeader,
    BCardBody, RfidForm, BRow, BCard, BCol, BAlert, BTable,BPagination,BDropdown, BDropdownItem, BProgress,
    BFormGroup, BFormInput, BInputGroup, BForm, BButton, BTabs, BCardText, BTab, BModal, vSelect, OrbitSpinner, ImportContainer
  },

  setup(props,{root}) {

    const search = ref('')

    const ownerFilterOptions = ref([])
    const sizeFilterOptions = ref([])
    const contractOptions = ref([])

    const progress = ref(false)

    const selectedCheckbox = ref([])
    const optionsChekcbox = [
      { text: root.$t('madinati jeddah'), value: 'cap' },
      { text: root.$t('madinati'), value: 'balady' },
    ]

    const error = ref(false)
    const errors = ref([])

    const send_tags = ref(false)

    let timeoutId  = null

    const qualify_form = ref({
      compactor: null,
      containers_file: null,
      services: [],
    })

    const contractFilterOptions = computed(() => {

      if (filteredOwners.value.length > 0) {
        return contractOptions.value.filter(i => {
          return filteredOwners.value.includes(i.contractor_id)
        })
      }

      return contractOptions.value

    })


    const devices = ref([])

    const getDevices = _ => {
      axios.get('userGetLinked', {params: {
          user: store.state.auth.userData.id,
          type: 'device',
          cols: 'device_id,name,owner_id,contract_id',
          category: 'COMPACTOR',
        }}).then(res => devices.value = res.data.data).catch(e => {})
    }

    getDevices()

    const onFileChange = (event) => {
      qualify_form.value.containers_file = event.target.files[0]
    }

    const sendQualification = () => {

      // console.log(qualify_form.value)
      errors.value = []
      send_tags.value = true

      const formData = new FormData()
      for (let i in qualify_form.value.services) {
        formData.append(`services[${i}]`, qualify_form.value.services[i])
      }
      formData.append('compactor', qualify_form.value.compactor)
      formData.append('containers_file', qualify_form.value.containers_file)

      axios.post('madinati-qualification', formData).then(response => {
        if (response.status === 200)
        {
          progress.value = true
          error.value = response.data.code === 1003;
          get_batch_progress(response.data.batch_id)
        }
      }).catch(e => {
        if (e.response.status === 422) {
          errors.value = e.response.data.errors
        }
      }).finally(_ => {
        send_tags.value = false
      })
    }


    const progress_value = ref(0)

    const get_batch_progress = (batch_id) => {
      axios.get(`get_batch_progress/${batch_id}`).then(response => {
        if (response.status === 200) {
          const _progress = response.data.progress;

          progress_value.value = _progress

          if (_progress < 100) {

            if (timeoutId !== null) {
              clearTimeout(timeoutId);
            }

            timeoutId = setTimeout(() => get_batch_progress(batch_id), 3000);

          } else {
            console.log('Import completed!');
            // progress.value = false
            // progress_value.value = 0
            qualify_form.value = {
              compactor: null,
              containers_file: null,
              services: [],
            }
          }
        }
      })
    }

    const filteredOwners = ref([])
    const filteredContracts = ref([])
    const filteredSizes = ref([])

    axios.get('filters/getFilterBy', { params: { type: 'container'}}).then(res => {
      if (res.status === 200) {

        for (const f in res.data.data) {
          switch (f) {
            case "contracts":
              contractOptions.value = res.data.data[f]
              break
            case "owners":
              ownerFilterOptions.value = res.data.data[f]
              break
            case "types":
              sizeFilterOptions.value = res.data.data[f]
              break
          }
        }
      }
    }).catch(e => console.log('cannot fetch containers filter'))


    const refTable = ref(null)
    const dataMeta = ref({})

    const tableColumns = [
      { key: 'id', sortable: false,label:root.$t('id')} ,
      { key: 'owner', sortable: true,label:root.$t('owner')} ,
      { key: 'contract', sortable: true,label: root.$t('contract')},
      { key: 'code', sortable: true,label:root.$t('code')} ,
      { key: 'tag', sortable: false,label:root.$t('tag')} ,
      { key: 'type', sortable: true,label:root.$t('container type')} ,
      { key: 'lastupdate', sortable: true,label:root.$t('lastlift')} ,
      { key: 'lastLatitude', sortable: false,label:root.$t('Latitude')} ,
      { key: 'lastLongitude', sortable: false,label:root.$t('Longitude')} ,
      { key: 'actions', sortable: false,label:root.$t('actions')}
    ]

    const perPageOptions = [25 , 50, 100, 500, 1000]
    const perPage = ref(25)

    const currentPage = ref(1)
    const loading = ref(false)

    const sortBy = ref('lastupdate')
    const sortDesc = ref(true)


    watch([search, perPage, currentPage], () => {
      refTable.value.refresh()
    })

    watch([filteredOwners, filteredSizes, filteredContracts], () => {
      if (filteredOwners.value.length > 0 || filteredSizes.value.length > 0 || filteredContracts.value.length > 0) {
        refTable.value.refresh()
      }
    })

    const onSortChanged = ctx => {
      sortBy.value = ctx.sortBy;
      sortDesc.value = ctx.sortDesc;
    }


    const fetchContainer = (ctx, callback) => {

      loading.value = true

      axios.get('containers', { params: {
          length: perPage.value,
          page: currentPage.value,
          sort: sortBy.value+','+sortDesc.value,
          ...(search.value && {q: search.value}),
          ...(filteredOwners.value.length > 0 && {owners: filteredOwners.value}),
          ...(filteredContracts.value.length > 0 && {contracts: filteredContracts.value}),
          ...(filteredSizes.value.length > 0 && {types: filteredSizes.value}),
        }}).then(r => {

          if (r.status === 200) {
            dataMeta.value = r.data.containers.meta
            callback(r.data.containers.data)
          }

      }).catch(e => console.log('cannot fetch containers'))
          .finally(() => loading.value = false)

    }

    const exportList = (exporter)=> {
      return new Promise((resolve,reject) => {
          axios.post('export', {
              export:'containersList', 
              exporter,
              ...(search.value && {q: search.value}),
              ...(filteredOwners.value.length > 0 && {owners: filteredOwners.value}),
              ...(filteredContracts.value.length > 0 && {contracts: filteredContracts.value}),
              ...(filteredSizes.value.length > 0 && {types: filteredSizes.value}),
          }, {responseType: 'blob'})
          .then( res => {
              resolve(new Blob([res.data], { type: res.headers['content-type'], encoding: 'UTF-8' }))
          })
          .catch( err => reject(err))
      })
    }

    const downloadList = (exporter)=> {
        loading.value = true
        exportList(exporter)
        .then((blob)=> {
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'containers-' + moment().format('YYYY-MM-DD HH:mm:ss') + '.' + exporter
          link.click()
        }).finally(()=> loading.value = false )
    }


    return {
      progress, progress_value, error, errors, send_tags,
      sendQualification,
      onFileChange, qualify_form,
      selectedCheckbox,
      optionsChekcbox,
      devices,
      ownerFilterOptions,
      contractFilterOptions,
      sizeFilterOptions,

      filteredContracts,
      filteredOwners,
      filteredSizes,

      hasPermission,
      currentPage, search,
      loading,
      fetchContainer,onSortChanged,

      refTable, dataMeta,
      tableColumns, perPageOptions, perPage,
      downloadList
    }

  }
}
</script>

<style scoped>

</style>
